module.exports = __webpack_public_path__ + "img/hauptspeise.391cf265.jpg";